import { useQuery } from "urql";

import { GetTradeInsuranceCustomerDocument } from "../../../graphql/generated.ts";

interface Props {
  customerId: number | null | undefined;
  pause: boolean;
}

export const useTradeInsuranceCustomer = ({ customerId, pause }: Props) => {
  return useQuery({
    query: GetTradeInsuranceCustomerDocument,
    variables: {
      customerId: customerId ?? 0,
    },
    pause,
  });
};
